<template>
  <oil-form v-if='loading'
            :title='title'
            :createForm='!id'
            :items='payment'
            :keys='keys'
            @ImporterId='changeImporter'
            @ContractId='changeContract'
            @InvoiceId='changeInvoice'
            :formCallback='formCallback'
  >
    <template v-slot:Amount='{input}'>
      <v-text-field
          :items='payment'
          label='Сумма'
          v-model='numAmount'
          :disabled='!input.isEdit'
          outlined
          dense
      >

      </v-text-field>
    </template>

    <template v-slot:Info>
      <h3>Информация</h3><br />
      <v-row>
        <v-col cols='4'>
          <v-text-field v-model='payment.Importer.Name' readonly outlined dense label='Названия фирмы' />
        </v-col>
        <v-col cols='4'>
          <v-text-field v-model='payment.Importer.Address' readonly outlined dense label='Юридический адрес' />
        </v-col>
        <v-col cols='4'>
          <v-text-field v-model='payment.Importer.Phone' readonly outlined dense label='Телефон' />
        </v-col>
      </v-row>
    </template>

  </oil-form>

</template>

<script>
import keys from './setting/coming_payment_impoter.json'
import { coreApi } from '~/services/core'
import { num2str } from '~/utils/functions/MoneyFromString'

export default {
  props: {
    id: String
  },
  data: () => ({
    numAmount: ' ',
    loading: false,
    title: 'Создать платеж',
    payment: {
      Importer: {},
      Contract: {},
      Invoice: {},
      Number: '',
      StartDate: '',
      Amount: '',
      AmountWords: '',
      Comment: '',
      AdditionalInformation: ''
    },
    keys: keys,
    importers: [],
    contracts: [],
    invoices: []
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  async created() {
    const importers = await coreApi.get(`importer`)
    this.importers = importers.data

    if (this.id) {
      this.title = 'Инфо о платежи'
      const payment = await coreApi.get(`coming-payment/importer?id=${this.id}`)
      this.payment = payment.data
      await this.changeImporter(this.payment.Importer)
    }

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message(){
      return this.id ? 'платеж удачно изменен' : 'платеж удачно создан'
    }
  },
  methods: {
    async formCallback(data, input, form, func) {
      input.isEdit = false
      const response = await this.storeType(`coming-payment/importer`, data)

      if (!response.data) {
        input.isEdit = true
        return
      }

      func(this.message)

      if (!this.id) {
        await this.$router.push({
          name: 'coming-payment-importer',
          params: { id: response.data.Id }
        })
      }

      input.isEdit = false
    },
    async changeImporter(importer) {
      if (!importer) return
      this.payment.Importer = { ...importer }
      this.contracts = importer.Contracts
      const invoices = await coreApi.get(`importer-invoice/importer/${importer.Id}`)
      this.invoices = invoices.data
      this.numAmount = this.payment.Amount;

    },
    async changeContract(contract) {
      if (!contract) return
      this.payment.Contract = { ...contract }
    },
    async changeInvoice(invoice) {
      if (!invoice) return
      this.payment.Invoice = { ...invoice }
    }
  },
  watch: {
    importers(importers) {
      this.keys['Importer.Id'].attrs.items = importers
    },
    contracts(contracts) {
      this.keys['Contract.Id'].attrs.items = contracts
    },
    invoices(invoices) {
      this.keys['Invoice.Id'].attrs.items = invoices
    },
    numAmount(amount) {
      this.payment.AmountWords = num2str(amount)
      this.numAmount = amount.toString().replaceAll(' ', '').replace(/\B(?=(\d{3})+(?!\d))/g, " " )
      this.payment.Amount = amount.toString().replaceAll(' ', '');
    }
  }
}
</script>
